export enum RoutePaths {
  HOME = '/home',
  WIDGETS = '/widgets',
  TRANSACTION = '/transaction',
  EMPLOYEES = '/employees/:storeId',
  YEARLYSTOCKTAKE = '/yearly-stock-take',
  KPITARGET = '/kpiTarget',
  SOLDPRODUCTS = '/soldProducts',
  DEVELOPMENT = '/development',
  PRODUCTCATEGORY = '/product-category',
  PROFITANDLOSS = '/profitAndLoss',
  WIDGETACCESSCONTROL = '/widget-access-control',
  SALESANALYSIS = '/salesAnalysis',
  ACCESSREQUESTS = '/access-requests',
  AREARESULT = '/area-result',
  PROFILE = '/profile',
  STORESLIST = '/stores-list',
}
